import { Card, CardBody } from "reactstrap";
import { ProductBrandData } from "../../../../../Data/Applications/ECommerce/ECommerce";
import { H5, LI, P, UL } from "../../../../../AbstractElements";

export const ShippingDetails = () => {
  return (
    <Card>
      <CardBody>
        <div className="collection-filter-block">
          <UL className="pro-services simple-list">
            {ProductBrandData.map((item, index) => (
              <LI key={index}>
                <div className="d-flex">
                  {item.icon}
                  <div className="flex-grow-1">
                    <H5>{item.text}</H5>
                    <P>{item.span}</P>
                  </div>
                </div>
              </LI>
            ))}
          </UL>
        </div>
      </CardBody>
    </Card>
  );
};
